import { Box, Typography } from "@mui/material";
import React from "react";
import { B } from "../B";

export function HistoryPage() {
  return (
    <Box>
      <Typography variant="h1">History of Santryl</Typography>{" "}
      <Typography>
        Santryl's history started when the six ancient Gods agreed on a
        collective experiment. Together, they blew apart the planes of an empty
        world, and oversaw the resultant patches of life. Together with the
        Giants, their first creations, they tended the new planes.
      </Typography>
      <Typography variant="h2">Formation</Typography>
      <Typography>
        One of the earliest continents to emerge after the planar separation,
        Santryl was the result of the Giants pulling together parts of the
        broken world and forging them into one landmass. From there they oversaw
        the gradual introduction of other species by the Gods, and supervised
        the development of the landscapes, ensuring good conditions for the new
        cultures to thrive. The Giants were proactive in these cultures for
        centuries, before leaving them to their own devices. They retreated to
        High Mount, and took residence deep in the caverns below. They remained
        available for counsel, and occasionally stirred to quell wars, but their
        interventions became fewer as the years went by.
        <B></B>Now they seldom leave their caverns, claiming their role as
        complete. They entrust the Dwarves with their locations, and whilst they
        don't encourage visitors, they will still willingly give advice to those
        that seek it.
      </Typography>
      <Typography>
        <B></B> The remaining species, most prominently the Dwarves, Elves,
        Humans, Rana, and various Goblinoids, settled into their respective
        cultures.
        <B></B>The Dwarves remained in High Mount, the mountains they claim to
        be the centre of the world. There they built citadels and towers, halls
        and towns, mines and excavations. They mostly keep to themselves, and
        have managed to maintain neutrality through the continent's various
        wars.
        <B></B> The Elves split in two; Some wanted to roam free the lands of
        Santryl, and became renowned wanderers, sharing stories and wisdom from
        across the continent. The others settled in the south west of Santryl,
        claiming lands for their own.
        <B></B>The Humans mostly stuck together, and together with the
        Halflings, built an industrious empire on the various metals in the
        north. What metals they didn't have access to they traded from the
        Dwarves, all to further their crafts and inventions. In the last century
        they have managed to build ships capable of travelling the great seas,
        and have been sending expeditionary forces off to seek new riches.
        <B></B>The Rana found a natural wonder: hot springs in the east, that
        are looked after by a lone Giant. Keeping their existence a secret, the
        Rana tend to the alpine forest with great care and caution. They welcome
        those that are deemed capable of showing restraint and wisdom, and
        reject those that they suspect would lead to the destruction of the
        springs.
        <B></B>The Goblinoids, numerous in their variations, spread out across
        Santryl. Though diverse in their forms, they remain singular in their
        roles as menaces to whichever culture happens to reside nearby. The
        lowly Goblin sticks to their pack, looting and scavenging for anything
        they can get their hands on. The Rock Goblin, hidden in the mountains,
        disrupt excavation sites and gnaw on the gemstones that decorate Dwarven
        architecture. The Hobgoblin fights to lead their warband, warring mostly
        with other Hobgoblin bands for something they've since forgotten about.
        The Bugbear, wisest of all Goblinoids, makes themself available for
        hire, as protection from threats on the road, such as other pesky
        Goblinoids.
      </Typography>
      <Typography variant="h2">Today's Nations</Typography>{" "}
      <Typography>
        In the thousands of years since the formation of Santryl as a continent,
        various cultures have come and gone, each warring and replacing one
        another. The spread of each species has stayed mostly consistent, but as
        time progresses, the more secluded species like the Rana drift into
        rumour, and the Giants into myth and legend. Now there remains four main
        nations in Santryl: The Unvariant Empire, The Galls, High Mount, and the
        Croaking conclave.
      </Typography>
    </Box>
  );
}
